import loggingService from '../services/util/loggingService'

var serviceName = 'landOwnershipService'
var path = '/LandOwnership/'
var isDebug = false

function listLandManagerTypes (http) {
    loggingService.log(isDebug, serviceName, 'listLandManagerTypes')
    return http.get(path + 'ListLandManagerTypes')
}

function listLandownerTypes (http) {
    loggingService.log(isDebug, serviceName, 'listLandownerTypes')
    return http.get(path + 'ListLandownerTypes')
}

function listLandTypes (http) {
    loggingService.log(isDebug, serviceName, 'listLandTypes')
    return http.get(path + 'ListLandTypes')
}

function remove (http, landOwnershipId) {
    loggingService.log(isDebug, serviceName, 'remove, landOwnershipId: ' + landOwnershipId)
    return http.delete(path + 'Remove?landOwnershipId=' + landOwnershipId)
}

function listLandOwnership (http, source, parentId) {
    loggingService.log(isDebug, serviceName, 'listLandOwnership, parentId: ' + parentId)
    return http.get('/' + source + '/ListLandOwnership?parentId=' + parentId)
}

function saveLandOwnership (http, source, landOwnershipDto) {
    loggingService.log(isDebug, serviceName, 'saveLandOwnership')
    return http.put('/' + source + '/SaveLandOwnership', landOwnershipDto)
}

var LandTypeList = [
    { id: 1, description: 'Block' },
    { id: 2, description: 'Extensive/Other' },
    { id: 3, description: 'Linear (feet)' }
]

var LandownerTypeList = [
    { id: 1, description: 'State' },
    { id: 2, description: 'Federal' },
    { id: 3, description: 'Private' },
    { id: 4, description: 'Multiple' },
    { id: 6, description: 'Tribal' },
    { id: 7, description: 'Other' },
    { id: 5, description: 'Unknown' }
]

export default {
    listLandManagerTypes: listLandManagerTypes,
    listLandownerTypes: listLandownerTypes,
    listLandTypes: listLandTypes,
    remove: remove,
    listLandOwnership: listLandOwnership,
    saveLandOwnership: saveLandOwnership,
    LandTypeList: LandTypeList,
    LandownerTypeList: LandownerTypeList
}



// WEBPACK FOOTER //
// ./src/services/landOwnershipService.js